<script>
import moment from 'moment'
import InputNumberRange from './components/InputNumberRange'
import Upload from './components/Upload'
import Ellipsis from '@/components/Ellipsis/index'
import IconSelect from './components/IconSelect.vue'
import ShiftTimePicker from './components/ShiftTimePicker'

export default {
  name: 'DForm',
  components: {
    InputNumberRange,
    Upload,
    Ellipsis,
    IconSelect,
    ShiftTimePicker,
  },
  props: {
    schema: {
      type: Object,
      default: () => ({}),
    },
    cols: {
      type: Number,
      default: 1,
    },
    ellipsisLength: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'd-form' }),
    }
  },
  methods: {
    onSelectChange(value, option, key) {
      this.$emit('selectChange', { value, option, key })
    },
    onRadioChange(e, key) {
      this.$emit('radioChange', { e, key })
    },
  },
  render() {
    let maxLength = 100
    if (this.cols === 1) {
      return (
        <a-form form={this.form} label-col={{ span: 6 }} wrapper-col={{ span: 16 }}>
          {Object.keys(this.schema.properties).map(key => {
            let item = null
            const prop = this.schema.properties[key]
            const vDecorator = [
              key,
              {
                initialValue: prop.default,
                preserve: false,
                rules: [
                  {
                    required:
                      this.schema.required &&
                      (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                    message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                  },
                ],
                trigger: 'change',
                validateFirst: false,
                validateTrigger: 'change',
                valuePropName: 'value',
              },
            ]
            if (!prop.ui) {
              prop.ui = { widget: 'input' }
            }
            if (!prop.ui.widget) {
              prop.ui.widget = 'input'
            }
            switch (prop.ui.widget) {
              case 'input':
                maxLength = prop.maxLength ? prop.maxLength : 100
                vDecorator[1].rules = [
                  {
                    required:
                      this.schema.required &&
                      (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                    message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                  },
                ]
                item = (
                  <a-input
                    v-decorator={vDecorator}
                    placeholder={prop.ui.placeholder}
                    disabled={prop.readOnly}
                    maxLength={maxLength}
                  />
                )
                break
              case 'textarea':
                maxLength = prop.maxLength ? prop.maxLength : 100
                vDecorator[1].rules = [
                  {
                    required:
                      this.schema.required &&
                      (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                    message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                  },
                ]
                item = (
                  <a-textarea
                    v-decorator={vDecorator}
                    placeholder={prop.ui.placeholder}
                    disabled={prop.readOnly}
                    maxLength={maxLength}
                  />
                )
                break
              case 'input-number':
                if (prop.ui.isSearch) {
                  vDecorator[1] = {
                    ...vDecorator[1],
                    initialValue: [0, 10],
                  }
                  item = <InputNumberRange  style="width:100%" v-decorator={vDecorator} />
                } else {
                  item = (
                    <a-input-number
                      style="width:100%"
                      v-decorator={vDecorator}
                      placeholder={prop.placeholder}
                      min={prop.ui.min}
                      max={prop.ui.max}
                      disabled={prop.readOnly}
                    />
                  )
                }
                break
              case 'select':
                item = (
                  <a-select
                    allowClear={prop.ui.allowClear}
                    v-decorator={vDecorator}
                    placeholder={prop.ui.placeholder}
                    mode={prop.ui.mode || 'default'}
                    disabled={prop.readOnly}
                    onChange={(v, o) => this.onSelectChange(v, o, key)}
                    show-search={!!prop.ui.showSearch}
                    optionFilterProp="children"
                  >
                    {prop.enum.map(item => {
                      return <a-select-option value={item.value}>{item.label}</a-select-option>
                    })}
                  </a-select>
                )
                break
              case 'date':
                if (prop.ui.isSearch) {
                  vDecorator[1] = {
                    ...vDecorator[1],
                    initialValue: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
                  }
                  item = (
                    <a-range-picker style="width:100%" showTime={prop.ui.showTime} v-decorator={vDecorator} disabled={prop.readOnly} />
                  )
                } else {
                  item = (
                    <a-date-picker
                      style="width:100%"
                      showTime={prop.ui.showTime}
                      placeholder={prop.ui.placeholder}
                      v-decorator={vDecorator}
                      disabled={prop.readOnly}
                      disabledDate={prop.ui.disabledDate}
                    />
                  )
                }
                break
              case 'radio':
                item = (
                  <a-radio-group
                    v-decorator={vDecorator}
                    disabled={prop.readOnly}
                    onChange={e => this.onRadioChange(e, key)}
                  >
                    {prop.enum.map(item => {
                      return <a-radio value={item.value}>{item.label}</a-radio>
                    })}
                  </a-radio-group>
                )
                break
              case 'switch':
                vDecorator[1].valuePropName = prop.default ? 'checked' :'unchecked'
                vDecorator[1].initialValue = prop.default
                item = <a-switch v-decorator={vDecorator} disabled={prop.readOnly} />
                break
              case 'upload':
                vDecorator[1] = {
                  ...vDecorator[1],
                  valuePropName: 'fileList',
                  getValueFromEvent: this.normFile,
                }
                item = <Upload v-decorator={vDecorator} />
                break
              case 'icon-select': {
                item = <IconSelect v-decorator={vDecorator} />
                break
              }
              case 'shift-time-picker': {
                item = <ShiftTimePicker v-decorator={vDecorator} />
                break
              }
              case 'text': {
                item = prop.title
                break
              }
              default:
            }
            return (
              <a-form-item
                label={
                  <Ellipsis tooltip length={this.ellipsisLength}>
                    {this.schema.properties[key].title}
                  </Ellipsis>
                }
                help={this.schema.properties[key].description}
                style={{ display: prop.hidden ? 'none' : 'block' }}
              >
                {item}
              </a-form-item>
            )
          })}
        </a-form>
      )
    } else if (this.cols === 2) {
      return (
        <a-form form={this.form} label-col={{ span: 6 }} wrapper-col={{ span: 16 }}>
          <a-row>
            {Object.keys(this.schema.properties).map(key => {
              let item = null
              const prop = this.schema.properties[key]
              const vDecorator = [
                key,
                {
                  initialValue: prop.default,
                  preserve: false,
                  rules: [
                    {
                      required:
                        this.schema.required &&
                        (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                      message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                    },
                  ],
                  trigger: 'change',
                  validateFirst: false,
                  validateTrigger: 'change',
                  valuePropName: 'value',
                },
              ]
              if (!prop.ui) {
                prop.ui = { widget: 'input' }
              }
              if (!prop.ui.widget) {
                prop.ui.widget = 'input'
              }
              switch (prop.ui.widget) {
                case 'input':
                  maxLength = prop.maxLength ? prop.maxLength : 100
                  vDecorator[1].rules = [
                    {
                      required:
                        this.schema.required &&
                        (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                      message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                    },
                  ]
                  item = (
                    <a-input
                      v-decorator={vDecorator}
                      placeholder={prop.ui.placeholder}
                      disabled={prop.readOnly}
                      maxLength={maxLength}
                    />
                  )
                  break
                case 'textarea':
                  maxLength = prop.maxLength ? prop.maxLength : 100
                  vDecorator[1].rules = [
                    {
                      required:
                        this.schema.required &&
                        (this.schema.required.includes(key) || this.schema.required.includes(`extendContent.${key}`)),
                      message: (prop.ui && prop.ui.requiredMessage) || this.$t('page_dform_must'),
                    },
                  ]
                  item = (
                    <a-textarea
                      v-decorator={vDecorator}
                      placeholder={prop.ui.placeholder}
                      disabled={prop.readOnly}
                      maxLength={maxLength}
                    />
                  )
                  break
                case 'input-number':
                  if (prop.ui.isSearch) {
                    vDecorator[1] = {
                      ...vDecorator[1],
                      initialValue: [0, 10],
                    }
                    item = <InputNumberRange v-decorator={vDecorator} />
                  } else {
                    item = (
                      <a-input-number
                        v-decorator={vDecorator}
                        placeholder={prop.placeholder}
                        min={prop.ui.min}
                        max={prop.ui.max}
                        disabled={prop.readOnly}
                      />
                    )
                  }
                  break
                case 'select':
                  item = (
                    <a-select
                      allowClear={prop.ui.allowClear}
                      v-decorator={vDecorator}
                      placeholder={prop.ui.placeholder}
                      mode={prop.ui.mode || 'default'}
                      disabled={prop.readOnly}
                      onChange={(v, o) => this.onSelectChange(v, o, key)}
                      show-search={!!prop.ui.showSearch}
                      filter-option={prop.ui.showSearch?prop.ui.filterOption:false}
                    >
                      {prop.enum.map(item => {
                        return <a-select-option value={item.value}>{item.label}</a-select-option>
                      })}
                    </a-select>
                  )
                  break
                case 'date':
                  if (prop.ui.isSearch) {
                    vDecorator[1] = {
                      ...vDecorator[1],
                      initialValue: [moment(), moment()],
                    }
                    item = (
                      <a-range-picker showTime={prop.ui.showTime} v-decorator={vDecorator} disabled={prop.readOnly} />
                    )
                  } else {
                    item = (
                      <a-date-picker
                        showTime={prop.ui.showTime}
                        v-decorator={vDecorator}
                        placeholder={prop.ui.placeholder}
                        disabled={prop.readOnly}
                        disabledDate={prop.ui.disabledDate}
                      />
                    )
                  }
                  break
                case 'radio':
                  item = (
                    <a-radio-group
                      v-decorator={vDecorator}
                      disabled={prop.readOnly}
                      onChange={e => this.onRadioChange(e, key)}
                    >
                      {prop.enum.map(item => {
                        return <a-radio value={item.value}>{item.label}</a-radio>
                      })}
                    </a-radio-group>
                  )
                  break
                case 'switch':
                  vDecorator[1].valuePropName = prop.default ? 'checked' :'unchecked'
                  vDecorator[1].initialValue = prop.default
                  item = <a-switch v-decorator={vDecorator} disabled={prop.readOnly} />
                  break
                case 'upload':
                  vDecorator[1] = {
                    ...vDecorator[1],
                    valuePropName: 'fileList',
                    getValueFromEvent: this.normFile,
                  }
                  item = <Upload v-decorator={vDecorator} />
                  break
                case 'icon-select': {
                  item = <IconSelect v-decorator={vDecorator} />
                  break
                }
                case 'shift-time-picker': {
                  item = <ShiftTimePicker v-decorator={vDecorator} />
                }
                case 'text': {
                  item = prop.title
                }
                default:
              }
              return (
                <a-col span={12}>
                  <a-form-item
                    label={
                      <Ellipsis tooltip length={this.ellipsisLength}>
                        {this.schema.properties[key].title}
                      </Ellipsis>
                    }
                    help={this.schema.properties[key].description}
                    style={{ display: prop.hidden ? 'none' : 'block' }}
                  >
                    {item}
                  </a-form-item>
                </a-col>
              )
            })}
          </a-row>
        </a-form>
      )
    } else {
      return null
    }
  },
}
</script>
<style lang="less" scoped>
.ant-form .ant-form-item:last-child{
  margin: 0 !important;
}
</style>
